// @flow

import React from 'react';
import styled, { css } from 'styled-components';
import { bottomPadding, flex, topPadding, Width } from 'styles';
import { BlockyContentItems } from 'templates';
import { AbsoluteBackground } from 'components/Gui';
import { BlockyFlexContainer } from 'components/Content';

const Wrapper = styled.section`
  position: relative;
  ${flex()};
  flex-direction: column;
  ${({ paddingTop }) => topPadding(...paddingTop)};
  ${({ paddingBottom }) => paddingBottom && bottomPadding(...paddingBottom)};

  @media print, screen and (min-width: ${Width.BREAK_XL}px) {
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
  }
`;

const Column = styled.div`
  width: 100%;
  z-index: 1;
`;

const Left = styled(Column)`
  z-index: 1;
  @media print, screen and (min-width: ${Width.BREAK_XL}px) {
    flex: 0 0 auto;
    width: ${({ desktopSectionWidth }) => desktopSectionWidth}px;
    margin-right: ${({ desktopSectionMarginRight }) => desktopSectionMarginRight}px;
    margin-left: ${({ desktopSectionMarginLeft }) => desktopSectionMarginLeft}px;
  }
  ${({ mobileReverse }) =>
    mobileReverse &&
    css`
      order: 2;

      @media print, screen and (min-width: ${Width.BREAK_XL}px) {
        order: unset;
      }
    `}
`;

type Props = {
  paddingTop?: number[],
  paddingBottom?: number[],
  background?: string,
  desktopSectionWidth: number,
  desktopSectionMarginRight?: number,
  desktopSectionMarginLeft?: number,
  contentLeft: any[],
  contentRight: any[],
  mobileReverse?: boolean,
};

const BlockyDesktopHorizontalSection = ({
  paddingTop = [84, 152, 152],
  paddingBottom,
  background,
  desktopSectionWidth,
  desktopSectionMarginRight = 0,
  desktopSectionMarginLeft = 0,
  contentLeft,
  contentRight,
  mobileReverse = false,
  ...rest
}: Props) => (
  <Wrapper paddingTop={paddingTop} paddingBottom={paddingBottom} {...rest}>
    {background && <AbsoluteBackground background={background} />}
    <Left
      mobileReverse={mobileReverse}
      desktopSectionWidth={desktopSectionWidth}
      desktopSectionMarginRight={desktopSectionMarginRight}
      desktopSectionMarginLeft={desktopSectionMarginLeft}>
      {contentLeft.map((itemContent, index) => (
        <React.Fragment key={`BlockyDesktopHorizontalSectionLeft-${index}`}>
          {!itemContent.contentMultiple && <BlockyContentItems {...rest} {...itemContent} />}
          {itemContent.contentMultiple && <BlockyFlexContainer {...rest} {...itemContent} />}
        </React.Fragment>
      ))}
    </Left>
    <Column>
      {contentRight.map((itemContent, index) => (
        <BlockyContentItems key={`BlockyDesktopHorizontalSectionRight-${index}`} {...rest} {...itemContent} />
      ))}
    </Column>
  </Wrapper>
);

BlockyDesktopHorizontalSection.contentType = 'BlockyDesktopHorizontalSection';

export default BlockyDesktopHorizontalSection;
